import Image from 'next/image'
import { Submenu } from '../../apis/navbar'
import Link from 'next/link'

interface SubMenuItemProps {
  item: Submenu
  className?: string
}

const SubmenuItem = ({ item, className }: SubMenuItemProps) => {
  const iconUrl = item.Icon?.url || ''
  return (
    <Link
      key={item.Id}
      href={item?.Path}
      locale={item.Locale}
      className={`flex cursor-pointer flex-row items-start justify-start pb-[0.75rem]  pl-[0.75rem] pr-[1.5rem] pt-[0.75rem] hover:bg-overlay-ghost-hover ${className}`}
    >
      {item.Icon && (
        <Image
          className='mr-[0.625rem] h-[5rem] w-[5rem]'
          src={iconUrl}
          width={100}
          height={100}
          alt=''
        />
      )}
      <div className='flex h-full flex-col'>
        <div className='mb-[0.5rem] text-[1rem] font-bold'>{item.Title}</div>
        <div className='text-[0.813rem]'>{item.Content}</div>
      </div>
    </Link>
  )
}

export default SubmenuItem
